import React from 'react';
import { Card, CardContent, Typography, Box, Stack, Divider } from "@mui/material";

const KatyBio = () => {
  return (
    <Card elevation={10} sx={{ maxWidth: 900, margin: "auto", padding: 3, boxShadow: 4, borderRadius: 3 }}>
      <CardContent>
        {/* Name & Title */}
        <Box textAlign="center" sx={{ mb: 3 }}>
          {/* Image of Katy */}
          <Box
            sx={{
              display: 'inline-block',
              borderRadius: '50%',
              overflow: 'hidden',
              width: 240, // Adjust as needed
              height: 240, // Adjust as needed
              mb: 2,
            }}
          >
            <img src="./katy.jpg" alt="Katy Monopoli" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </Box>
          <Typography variant="h4" color="primary" gutterBottom>
            Kathryn (Katy) Monopoli
          </Typography>
          <Typography variant="h6" color="textSecondary" gutterBottom>
            Bioinformatics Ph.D. Candidate
          </Typography>
        </Box>
        <Divider sx={{ my: 2 }} />

        {/* Bio Description */}
        <Stack spacing={2}>
          <Typography variant="body1">
            Kathryn (Katy) Monopoli is a soon to be graduating Bioinformatics Ph.D. candidate in
            {" "}
            <a href="https://www.umassmed.edu/khvorovalab/" target="_blank" rel="noopener noreferrer">
              Anastasia Khvorova's lab
            </a>
            {" "}
            co-advised by the machine learning expert 
            {" "}
            <a href="https://www.wpi.edu/people/faculty/dkorkin/" target="_blank" rel="noopener noreferrer">
              Dmitry Korkin
            </a>
            {" "}
            in the Bioinformatics and Computer Science Departments at 
            Worcester Polytechnic Institute (WPI).
          </Typography>

          <Typography variant="body1">
            Katy develops and applies machine learning (ML) techniques to study therapeutic small RNAs, with expertise in 
            developing models applying artificial intelligence (AI) for the accurate prediction of potent therapeutic small interfering RNAs (siRNAs). 
            Her algorithms and models have been applied to design more than 10,000 synthesized siRNAs. She holds thirteen patents 
            specific to therapeutic siRNA design, including several that have been licensed to biotech companies. 
            Her work has contributed to over ten publications, on three of which she is the primary author.
          </Typography>

          <Typography variant="body1">
            Katy's research bridges biology with computer science to advance therapeutic development and, more generally, expand our 
            understanding of biological processes. She is passionate about increasing access to advanced computational concepts including 
            AI/ML methods for life science researchers without computational training, through developing easy-to-use computational tools that 
            do not require any computer programming knowledge.
          </Typography>
        </Stack>

        <Divider sx={{ my: 3 }} />

        {/* Research Overview */}
        <Typography variant="h5" color="primary" gutterBottom>
          Research Focus
        </Typography>

        <Stack spacing={2}>
          <Typography variant="body1">
            Therapeutic siRNAs require complete chemical stabilization to enable long-term functional efficacy in vivo. 
            The activity of siRNA within an endogenous environment is defined by efficient and productive interactions 
            with the RNA-Induced Silencing Complex (RISC), as well as features related to mRNA structure, cellular localization, 
            and interactions with other intracellular proteins and miRNAs.
          </Typography>

          <Typography variant="body1">
            Using a database of more than 5,000 fully chemically modified siRNA sequences, we have developed a model for 
            efficiently predicting the efficacy of therapeutic siRNAs. Performance enhancement is achieved through 
            semi-supervised feature extraction, incorporating whole human and mouse transcriptome data to capture 
            mRNA-specific features. Currently, the model is trained on human and mouse transcriptomes and includes 
            information for predicting rat and macaque compounds, albeit with lower predictive power.
          </Typography>
        </Stack>

        <Divider sx={{ my: 3 }} />

        {/* References */}
        <Typography variant="body2" color="textSecondary">
          For an overview of current *siRNA therapeutic trends*, please refer to 
          <b> Eagli and Manoharan (2023, NAR)</b> and <b>Tang and Khvorova (2024, Nature Reviews Drug Discovery)</b>.
        </Typography>
      </CardContent>
    </Card>
  );
};

export default KatyBio;